module.exports = __webpack_public_path__ + "img/header-empty.871b0675.png";